import * as React from 'react'
import { Status } from './Status'
import * as style from './style.scss'

interface IAnimatedStatusSignProps {
    /** Status object which is used to determine animated sign layout */
    status: Status
}

/**
 * Shows an animated status sign for a given status e.g. checkmark for success
 * @param status requires status object to show animation
 */
const AnimatedStatusSign: React.FunctionComponent<IAnimatedStatusSignProps> = ({ status }) => {
    let classes = style.animatedStatusSign
    switch (status) {
        case Status.Success:
            classes += ' ' + style.success
            break
        case Status.Warning:
            classes += ' ' + style.warning
            break
        case Status.Error:
            classes += ' ' + style.error
            break
    }
    return (
        <div className={style.animatedStatusSignContainer}>
            <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle className={style.circle} cx="26" cy="26" r="25" fill="none" />

                {status === Status.Success &&
                    <path className={style.checkmark} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                }

                {status === Status.Warning &&
                    <svg className={style.exclamation} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <path d="M26,11.919L26,32.128" className={style.exclamation1} />
                        <path d="M26,36.091L26,40.081" className={style.exclamation2} />
                    </svg>
                }

                {status === Status.Error &&
                    <svg className={style.cross} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <path className={style.cross1} d="M36.484,36.484L15.516,15.516" />
                        <path className={style.cross2} d="M36.484,15.516L15.516,36.484" />
                    </svg>
                }
            </svg>
        </div>
    )
}

export default React.memo(AnimatedStatusSign)
